<template>
  <section style="position:relative" id="section">

    <el-row class="statusRow">
    
      <el-button size="medium" type="primary" @click="createBillData">生成账单</el-button>
      <el-button size="medium" type="primary" @click="createBillDataOne()">批量生成账单</el-button>
      <el-button size="medium" type="primary" @click="createBillDataALl(0)">一键批量生成账单</el-button>
      <!--<el-input
	        @clear="getList"
	        @keyup.enter.native="search"
	        ref="input"
	        class="search  xs24"
	        v-model="pdata.kw"
	        clearable
	        placeholder="请输入公司名称"
	        :suffix-icon="pdata.kw.length>0?'':'el-icon-search'"
	    ></el-input>-->
	    
	
			<el-select v-model="pdata.kw" filterable  clearable    placeholder="请选择公司名称">
		    <el-option
		      v-for="item in companyList"
		      :key="item.id"
		      :label="item.name"
		      :value="item.id">
		    </el-option>
			</el-select>
      &nbsp;账单周期：  &nbsp;
		  <el-date-picker
	      v-model="monthVal"
	      type="monthrange"
	      @change="monthValChange"
	      range-separator="至"
	      start-placeholder="开始月份"
	      end-placeholder="结束月份"
	      format="yyyy 年 MM 月"
        value-format="yyyyMM">
	    </el-date-picker>
	  
	    <el-select class="xs24" v-model="pdata.stype" placeholder="请选择结算账单周期"  clearable >
						    <el-option key="1" label="周" value="1"></el-option>
						    <el-option key="2" label="半月" value="2"></el-option>
						    <el-option key="3" label="月" value="3"></el-option>
			</el-select>
			 <!--<el-select class="xs24" v-model="pdata.status" placeholder="请选择账单状态"  clearable >
						    <el-option key="0" label="未对账" value="0"></el-option>
						    <el-option key="1" label="开票中" value="1"></el-option>
						    <el-option key="2" label="已结清" value="2"></el-option>
						    <el-option key="-1" label="已作废" value="-1"></el-option>
			</el-select>-->
			<el-select class="xs24" v-model="pdata.invoice_type" placeholder="请选择发票类型"  clearable >
						    <el-option key="1" label="普通发票" value="1"></el-option>
						    <el-option key="2" label="增值税发票" value="2"></el-option>
			</el-select>

     
		 
    </el-row>
    
    <el-row  style="padding:15px 15px 55px 15px;background:#fff">
    	<el-tabs v-model="pdata.status" type="card" >
		    <el-tab-pane label="未对账" name="0"></el-tab-pane>
		    <el-tab-pane label="已核对" name="1"></el-tab-pane>
		    <el-tab-pane label="开票中" name="2"></el-tab-pane>
		    <el-tab-pane label="待收款" name="3"></el-tab-pane>
		    <el-tab-pane label="已收款" name="4"></el-tab-pane>
		    <el-tab-pane label="已作废" name="-1"></el-tab-pane>
		  </el-tabs>

    
	    <!--列表-->
	    <el-table
	      :data="plist"
	      style="width: 100%;min-width:1200px"
	      stripe
	      row-key="id"
	      @selection-change="select"
	      class="demo-table"
	      show-summary
	      :summary-method="getSummaries" 
	      :height="710"
	    >
	     <el-table-column type="selection" min-width="30px"></el-table-column>
	     <el-table-column prop="id"  label="ID" min-width="50px" width="50" align="center"></el-table-column>
	     <el-table-column prop="company_name"  label="公司名称"  align="center"  min-width="100px"></el-table-column>
	     <el-table-column prop="bill_sdate"  label="结算日期" min-width="120px" align="center" >
	     		<template slot-scope="scope">
						<span>{{scope.row.bill_sdate}}~{{scope.row.bill_edate}}</span>
		      </template>
	     	
	     </el-table-column>
	     
	      <el-table-column prop="stype"  label="结算周期" min-width="50px" align="center">
	     		<template slot-scope="scope">
						<span v-if="scope.row.stype==1">周结</span> 
						<span v-else-if="scope.row.stype==2">半月结</span> 
						<span v-else-if="scope.row.stype==3">月结</span> 
					
		      </template>
	     </el-table-column>
	     
	     <el-table-column prop="bill_amount" label="结算金额" align="center" sortable :sort-method="(a,b)=>{return (a.bill_amount-0)-(b.bill_amount-0)}"></el-table-column>
	     
	     <el-table-column prop="num"  label="导量人数" min-width="50px" align="center"  sortable :sort-method="(a,b)=>{return (a.num-0)-(b.num-0)}"></el-table-column>
	     <el-table-column prop="invoice_type"  label="发票类型" min-width="50px" align="center">
	     		<template slot-scope="scope">
						<span>{{scope.row.invoice_type==1?'普通发票':'增值发票'}}</span> 
		      </template>
	     </el-table-column>
	     <el-table-column prop="type"  label="结算类型" min-width="50px" align="center">
	     		<template slot-scope="scope">
						<span v-if="scope.row.type==1">对公</span> 
						<span v-else-if="scope.row.type==2">对私</span> 
					
		      </template>
	     </el-table-column>
	    
	     <el-table-column prop="bill_amount_offset"  label="抵扣后金额" min-width="60px" align="center" sortable :sort-method="(a,b)=>{return (a.bill_amount_offset-0)-(b.bill_amount_offset-0)}">
	     	<template slot-scope="scope">
						<span v-if="scope.row.bill_amount_offset>0">{{scope.row.bill_amount_offset}}</span> 
						<span v-else>0</span> 
		      </template>
	     </el-table-column>
	    <el-table-column prop="offset"  label="是否抵扣" min-width="60px" align="center">
	     		<template slot-scope="scope">
	     			<el-button  v-if="scope.row.offset==0" size="mini" type="info"  @click="billOffset(scope.row,1)">否</el-button>
	     			<el-button  v-if="scope.row.offset==1" size="mini" type="primary"  @click="billOffset(scope.row,0)">是</el-button>
		      </template>
	     </el-table-column>
	     
	
	     <el-table-column prop="status"  label="状态" min-width="80px"  align="center">
	     		<template slot-scope="scope">
	     			<div v-if="groupid==0||groupid==1">
	     				  <el-button size="mini" type="primary" v-if="scope.row.status==0" @click="billEdit(scope.row)">未对账</el-button>
			          <el-button size="mini" type="primary" v-if="scope.row.status==1" @click="billEdit(scope.row)">已核对</el-button>
			          <el-button size="mini" type="warning" v-if="scope.row.status==2"  @click="billEdit(scope.row)">开票中</el-button>
			          <el-button size="mini" type="success" v-if="scope.row.status==3"  @click="billEdit(scope.row)">待收款</el-button>
		          	<el-button size="mini" type="success" v-if="scope.row.status==4"  @click="billEdit(scope.row)">已收款</el-button>
		          	<el-button size="mini" type="text" v-if="scope.row.status==-1"  @click="billEdit(scope.row)">已作废 </el-button>
	     			</div>
	     			<div v-if="groupid==4">
	     				  <el-button size="mini" type="primary" v-if="scope.row.status==0" @click="billEdit(scope.row)">未对账</el-button>
			          <el-button size="mini" type="primary" v-if="scope.row.status==1" @click="billEdit(scope.row)">已核对</el-button>
			          <el-button size="mini" type="warning" v-if="scope.row.status==2"  @click="billEdit(scope.row)">开票中</el-button>
			          <el-button size="mini" type="text" v-if="scope.row.status==3" >待收款</el-button>
	          	  <el-button size="mini" type="text" v-if="scope.row.status==4" >已收款</el-button>
			          <el-button size="mini" type="info" v-if="scope.row.status==-1"  @click="billEdit(scope.row)">已作废 </el-button>
	     			</div>
	     			<div v-if="groupid==13">
	     				 <el-button size="mini" type="text" v-if="scope.row.status==0" >未对账</el-button>
			         <el-button size="mini" type="text" v-if="scope.row.status==1">已核对</el-button>
			         <el-button size="mini" type="text" v-if="scope.row.status==2" >开票中</el-button>
	     				<el-button size="mini" type="success" v-if="scope.row.status==3"  @click="billEdit(scope.row)">待收款</el-button>
	          	<el-button size="mini" type="success" v-if="scope.row.status==4"  @click="billEdit(scope.row)">已收款</el-button>
	          	<el-button size="mini" type="text" v-if="scope.row.status==-1"  @click="billEdit(scope.row)">已作废 </el-button>
	     			</div>
	        </template>
	     </el-table-column>
	     <el-table-column prop="status"  label="操作" min-width="50px" width="400"  align="center">
	     		 <template slot-scope="scope">
							<el-button size="medium" type="primary" icon="el-icon-edit" @click="updateBillData(scope.row)">更新账单</el-button>
							<el-button size="medium"  @click="$router.push({name:'账单详情明细',params:{index_id:scope.row.id},query:{bill_date:scope.row.bill_date}})">明细</el-button>
							<!--<el-button size="medium"  @click="editRule(scope.row)">下载</el-button>-->
							<el-button size="medium"  @click="openDealy(scope.row.id)">操作日志</el-button>
	     		 </template>
	     </el-table-column>
	     
	    
	    </el-table>

	    
	  
    </el-row>
  	<el-row class="pageRow">
		<el-pagination
	        class="pagination"
	        @size-change="SizeChange"
	        @current-change="CurrentChange"
	        :current-page.sync="pdata.page"
	        :page-sizes="[20, 40, 60, 80,200]"
	        :page-size="pdata.perpage"
	        background
	        layout="sizes, prev, pager, next, jumper"
	        :total="pdata.perpage*maxPage"
	      ></el-pagination>
    </el-row>
    <el-dialog
      :title="isAdd?'账单生成':'账单生成'"
      :visible.sync="editDialog"
      top="5vh"
      width="750px"
      custom-class="dialog"
      :close-on-click-modal="false"
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	
        <el-row :gutter="5" style="margin:0;">
        	<el-col :span="24">
        		<el-form-item label="选择结算公司">
        			 <el-select v-model="chooseCompany" filterable  clearable multiple   placeholder="请选择">
						    <el-option
						      v-for="item in companyList"
						      :key="item.id"
						      :label="item.name"
						      :value="item.id">
						    </el-option>
						  </el-select>
        		</el-form-item>
        	</el-col>
        </el-row>
        
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="editDialog = false">取 消</el-button>
        <el-button type="primary" @click="buildBillData">确 定</el-button>
      </div>
    </el-dialog>
    
    
     <el-dialog
      :title="isAdd?'结算':'结算'"
      :visible.sync="billDialog"
      top="5vh"
      width="950px"
      custom-class="dialog"
      :close-on-click-modal="false"
      center
    >
      <el-form :model="chooseProduct" :rules="rules" ref="ruleForm" :label-width="formLabelWidth">
      	    <!--列表-->
				    <!--<el-table
				      :data="billList"
				      style="width: 100%;"
				      stripe
				      row-key="id"
				      class="demo-table"
				     
				    >
				    <el-table-column label="结算对账单" align="center">        
								<el-table-column prop="bill_date" label="结算周期" align="center" width="200px" >
									<template slot-scope="scope">
										<span>{{scope.row.bill_sdate}}~{{scope.row.bill_edate}}</span>
					      </template>
								</el-table-column>
							
								
								<el-table-column prop="product_name" label="游戏名称" align="center" width="150px"></el-table-column>
								<el-table-column prop="channel_name" label="渠道名称" align="center" width="150px"></el-table-column>
								<el-table-column prop="platform" label="平台" align="center"></el-table-column>
								<el-table-column prop="type" label="合作方式" align="center" ></el-table-column>
								<el-table-column prop="num" label="新增人数" align="center" ></el-table-column>
								<el-table-column prop="unit" label="单价（元/个）" align="center" ></el-table-column>
								<el-table-column prop="amount" label="应收金额（￥）" align="center" >
										
								</el-table-column>
						</el-table-column>								      	
				    </el-table>-->
				    
				    <div  class="el-table demo-table el-table--fit el-table--striped el-table--border el-table--group el-table--enable-row-hover el-table--enable-row-transition" id="ta" style="width: 100%;">
	
							<div class="el-table__header-wrapper">
								<table cellspacing="0" cellpadding="0" border="0" class="el-table__header" style="width: 900px;"  id="ta">
									<colgroup>
										<col name="el-table_3_column_28_column_29" width="160">
										<col name="el-table_3_column_28_column_30" width="120">
										<col name="el-table_3_column_28_column_31" width="120">
										<col name="el-table_3_column_28_column_32" width="70">
										<col name="el-table_3_column_28_column_33" width="80">
										<col name="el-table_3_column_28_column_34" width="80">
										<col name="el-table_3_column_28_column_35" width="135">
										<col name="el-table_3_column_28_column_36" width="135">
										<col name="gutter" width="0">
									</colgroup>
									<thead class="is-group has-gutter">
										<tr class="">
											<th colspan="8" rowspan="1" class="el-table_3_column_28  is-center  ">
												<div class="cell">结算对账单</div>
											</th>
										
										</tr>
										<tr class="">
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_29  is-center   is-leaf">
												<div class="cell">结算周期</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_30  is-center   is-leaf">
												<div class="cell">游戏名称</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_31  is-center   is-leaf">
												<div class="cell">渠道名称</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_32  is-center   is-leaf">
												<div class="cell">平台</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_33  is-center   is-leaf">
												<div class="cell">合作方式</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_34  is-center   is-leaf">
												<div class="cell">新增人数</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_35  is-center   is-leaf">
												<div class="cell">单价（元/个）</div>
											</th>
											<th colspan="1" rowspan="1" class="el-table_3_column_28_column_36  is-center   is-leaf">
												<div class="cell">应收金额（￥）</div>
											</th>
											
										</tr>
									</thead>

									<tbody class="el-table__body">
										<tr class="el-table__row" :class="index%2==1?'el-table__row--striped':''" v-for="item,index in billList">
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_29 is-center ">
												<div class="cell"><span >{{item.bill_sdate}}~{{item.bill_edate}}</span></div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_30 is-center ">
												<div class="cell">{{item.product_name}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_31 is-center ">
												<div class="cell">{{item.channel_name}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_32 is-center ">
												<div class="cell">{{item.platform}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_33 is-center ">
												<div class="cell">{{item.type}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_34 is-center ">
												<div class="cell">{{item.num}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_35 is-center ">
												<div class="cell">{{item.unit}}</div>
											</td>
											<td rowspan="1" colspan="1" class="el-table_3_column_28_column_36 is-center ">
												<div class="cell">{{item.amount}}</div>
											</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="8" class="el-table_3_column_28_column_36 is-center ">&nbsp;</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">结算类型	</td>
						    			<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{company.type==1?'企业':'个人'}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">发票类型	</td>
						    			<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{bill.invoice_type==1?'普通发票':'增值发票'}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">新增用户	</td>
						    			<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{bill.num}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">税点	</td>
						    			<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{bill.tax_point}}%	</td>
										</tr>
										<tr v-if="bill.offset==1">
											<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">抵扣金额	</td>
						    			<td rowspan="1" colspan="5" class="el-table_3_column_28_column_36 is-center ">{{bill.offset_amount}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center " v-if="company.type==1">结算金额	</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center " v-if="company.type==2">结算金额(扣去税点后金额)	</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{bill.bill_amount}}	</td>
										</tr>
										<tr>
												<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">结算金额（人民币大写）	</td>
						    				<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{bill.big_bill_amount}}	</td>
										</tr>
										<tr>
											<td rowspan="1" colspan="8" class="el-table_3_column_28_column_36 is-center ">&nbsp;</td>
										</tr>
										
										<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">甲方公司 ：{{company.name}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[0]}}</td>
							    	</tr>
							    	
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">税号：{{company.social_credit_code}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[3]}}</td>
							    	</tr>
							    	<tr>
								    <td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">注册地址：{{company.company_addr}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[4]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">注册电话：{{company.company_phone}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[8]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">开户银行 ：{{company.opening_bank}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[1]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">银行 账号：{{company.receiving_account}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[2]}}</td>
							    	</tr>
							    
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">联系人：{{company.contact}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[6]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">联系电话：{{company.phone}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[7]}}</td>
							    	</tr>
							    	<tr>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">邮寄地址：{{company.email_addr}}</td>
								    	<td rowspan="1" colspan="4" class="el-table_3_column_28_column_36 is-center ">{{wecompany[5]}}</td>
							    	</tr>
										
										
										
										<!---->
									</tbody>
									
								</table>
							</div>

						</div>
				  
    
      </el-form>
      <div slot="footer" class="dialog-footer">
      	<el-button type="primary" @click="ChangeBillDataStatus(bill.id,1)" v-if="bill.status==0">确认对账</el-button>
      	<el-button type="primary" @click="ChangeBillDataStatus(bill.id,2)" v-if="bill.status==1">确认核对</el-button>
      	<el-button type="primary" @click="ChangeBillDataStatus(bill.id,3)" v-if="bill.status==2">确认开票</el-button>
      	<el-button type="primary" @click="ChangeBillDataStatus(bill.id,4)" v-if="bill.status==3">确认付款</el-button>
      	<el-button type="primary" @click="ChangeBillDataStatus(bill.id,0)" v-if="bill.status==-1">确认恢复</el-button>
        <el-button @click="ChangeBillDataStatus(bill.id,-1)">作废</el-button>
        
        <el-button @click="tableToExcel" >导出Excel</el-button>
        <el-button @click="billDialog = false">取消</el-button>
       
      </div>
    </el-dialog>
    


    <el-dialog title="更新日志" :visible.sync="logDialog">
      <el-table :data="plog">
        <el-table-column prop="username" label="操作人员" width="150"></el-table-column>
        <el-table-column prop="create_time" label="更新时间" width="200"></el-table-column>
        <el-table-column prop="content" label="备忘"></el-table-column>
      </el-table>
    </el-dialog>
  </section>
</template>

<script>
import { getBillDataList,  billDataStatus, billDataAdd ,selectCompany,getBillDataDetail,sclog,postBillOffset} from "../../api/api";
//import UploadImg from "./uploadImg.vue";
import { mapGetters } from 'vuex';
export default {
  components: {
//  UploadImg
  },
  data() {
    return {
      rules: {
        name: [{ required: true, message: "请输入企业/个人名称", trigger: "blur" }],
        opening_bank:[{ required: true, message: "请输入开户行", trigger: "blur" }],
        receiving_account:[{ required: true, message: "请输入收款账号", trigger: "blur" }]
      },
      isFy: false,
      fy: { name: "ces" },
      pdata: {
        page: 1,
        perpage: 20,
        issued_app_name:"",
        theme: "",
        status: "",
        kw: "",
        sort_field: "",
        sort_by: "",
        placement:"",
				stype:"",
				invoice_type:"",
				date:'',
      },
      monthVal: [],
      bdata:{ 
      	company_id:0,
        bill_date:''
      },
      plist: [],
      billList:[],
      company:'',
      wecompany:[],
      bill:'',
      companyList:[],
      chooseCompany:'',
      maxPage: 1,
      config: [],
      tags: [],
      editDialog: false,
      formLabelWidth: "100px",
      chooseTags: [],
      plog: [], //日志
      logDialog: false,

      sText: "请选择产品状态",
      tText: "请选择产品题材",
      pText:"请选择产品投放位置",
      imageUrl: "",

      headMsg: {
        token: ""
      },
      imageUrl: "",
      isAdd: false,
      cP: {
        index_id: "",
        status: "1",
        log: ""
      }, //修改选中的产品状态,批量修改状态
      selectProduct: [], //批量修改选中的产品
      prWidth: 0,
      chooseProduct: {
      	"type":"1",
			  "name":"",
				"opening_bank":"",
				"receiving_account":"",
				"social_credit_code":"",
				"contact":"",
				"phone":"",
				"invoice_type":"",
				"tax_point":"",
				"company_addr":"",
				"email_addr":"",
				"remark":"",
				"log":""
			},
			billDialog:false,
    };
  },
  watch: {
  	"pdata.stype": {
      handler(n, o) {
      	this.getList();
      },
      deep: true
    },
    "pdata.invoice_type": {
      handler(n, o) {
      	this.getList();
      },
      deep: true
    },
    "pdata.status": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    },
    "pdata.kw": {
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    },
    "pdata.date":{
    	handler(n, o) {
      	this.getList();
    	},
      deep: true
    }

  },
  methods: {
  	getSummaries(param) {
		    const { columns, data } = param;
		    const sums = [];
		    columns.forEach((column, index) => {
		      if (index === 0) {
		        sums[index] = '合计';
		        return;
		      }

	      	if(index === 1||index===2||index===3||index===4||index===7||index===8||index===10||index===11||index===12){
	      	 		 sums[index] = '-';
	      	 			return;
	      	 }
		     
		      
		   	
	
		     
		      const values = data.map(item => Number(item[column.property]));
		      if (!values.every(value => isNaN(value))) {
		        sums[index] = values.reduce((prev, curr) => {
		          const value = Number(curr);
		          if (!isNaN(value)) {
		            return prev + curr;
		          } else {
		            return prev;
		          }
		        }, 0);
		        sums[index] = sums[index].toFixed(2)  ;
		      } else {
		        sums[index] = '-';
		      }
		    });
		
		    return sums;
		},
  	monthValChange(){

  		this.pdata.date= this.monthVal[0]+'-'+this.monthVal[1]
  	},
  	//数据导出
    handleDownload() {
      var that = this;
      var arr = [];
      var arrHd = ["开始日期","结束日期", "游戏名称", "渠道名称", "平台","合作方式","新增人数","单价(元/个)","应收金额"];
      var arrFval = ["bill_sdate","bill_edate","product_name","channel_name", "platform","type","num","unit","bill_amount" ];
//    if (that.tablelistAll.length > 0) {
//      that.exclelist = arr.concat(that.tablelistAll);
//    } else {
//      that.exclelist = arr.concat(that.tablelist);
//      arrHd = arrHd.splice(1);
//      arrFval = arrFval.splice(1);
//    }
      that.billList.forEach((v,i)=> {
        v.bill_amount = v.num*v.unit
      });
      console.log(that.billList);
      if (that.billList == "") {
        return false;
      }

      console.log(arrHd);
      console.log(arrFval);
      require.ensure([], () => {
        const {
          export_json_to_excel,
          export_table_to_excel
        } = require("../../vendor/Export2Excel.js");
        const tHeader = arrHd;
        const filterVal = arrFval;
        const list = this.billList;

        const data = this.formatJson(filterVal, list);
				data.push([""])
				data.push([""])
        data.push(["结算类型",this.company.type==1?"企业":"个人"])
        data.push(["发票类型",this.bill.invoice_type==1?'普通发票':'增值发票'])
        data.push(["新增用户",this.bill.num])
        data.push(["税点",this.bill.tax_point+'%'])
        data.push([this.company.type==1?"结算金额":"结算金额(扣去税点后金额)",this.bill.bill_amount])
        data.push(["结算金额（人民币大写）",this.bill.big_bill_amount])
        data.push([""])
        data.push([""])
        data.push(["甲方公司:"+this.company.name,null,null,null,this.wecompany[0]])
        data.push(["税号:"+this.company.social_credit_code,null,null,null,this.wecompany[3]])
        data.push(["注册地址:"+this.company.company_addr,null,null,null,this.wecompany[4]])
        data.push(["注册电话:"+this.company.company_phone,null,null,null,this.wecompany[8]])
        data.push(["开户银行:"+this.company.opening_bank,null,null,null,this.wecompany[1]])
        data.push(["银行账号:"+this.company.receiving_account,null,null,null,this.wecompany[2]])
        data.push(["联系人:"+this.company.contact,null,null,null,this.wecompany[6]])
        data.push(["联系电话:"+this.company.phone,null,null,null,this.wecompany[7]])
        data.push(["邮寄地址:"+this.company.email_addr,null,null,null,this.wecompany[5]])


				   	
				   	
       
        
      
        export_json_to_excel(
          tHeader,
          data,
          this.company.name+"结算对账单"
        );
//      export_table_to_excel("ta");
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
  	search() {
      this.getList();
    },
  	ChangeBillDataStatus(id,status){
  		var log="";
  		if(status==1){
  			log='确认对账';
  		}
  		else if(status==2){
  			log='确认核对';
  		}
  		else if(status==3){
  			log='确认开票';
  		}
  		else if(status==4){
  			log='确认收款';
  		}
  		else if(status==-1){
  			log='确认作废';
  		}
  		else if(status==0){
  			log='确认恢复';
  		}
		  this.$prompt("您将"+log+"该账单，是否继续？", log, {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          inputPlaceholder:"填写备注（可以为空）"
        }).then(({ value }) => {
        			if(value){
        				 log =log +'-'+value;
        			}
             
           		billDataStatus({"index_id":id,"status":status,log:log}, this.$cookie.getCookie("login")).then(res => {
			        if (res.code == 200) {
			        	 this.billDialog = false;
			        	 this.getList();
			        	 
			        }
			     });
        });
 
  	},
  	billEdit(r){
  		this.bdata.company_id=r.company_id;
  		this.bdata.bill_date=r.bill_date;
  		this.getBillList(r.status,r.company_id,r.id);
  	},
  	billOffset(r,offset){
  		postBillOffset({"bill_data_id":r.id,"offset":offset}, this.$cookie.getCookie("login")).then(res => {
					        if (res.data.code == 200) {
					        	 this.editDialog = false;
					        	 this.$notify({
						          title: "通知",
						          message:"成功",
						          type: "success"
						        });
						      	this.getList();
					        }
					        else{
	
					        	this.$notify.error({
						          title: '错误',
						          message: res.data.msg
						        });
					        }
					       
					     });
  	},
  	createBillData(){
  		 this.editDialog = true;
  	},
  	buildBillData(){
  		if(this.chooseCompany.length<1){
  			this.$message.error("请先选择需要生成账单的公司");
  		}
  		else{
  			
  			  	var p = this.chooseCompany;
  			  		
			  		p.forEach((v,i)=>{
			  			billDataAdd({"index_id":v}, this.$cookie.getCookie("login")).then(res => {
					        if (res.code == 200) {
					        	 this.editDialog = false;
					        	 this.$notify({
						          title: '通知',
						          message: res.data.company+ "成功",
						          type: 'success'
						        });
					        	
					        }
					        else{
					        	this.$message.error(res.msg);
					        }
					     });
			  		})
  		}
  	},
  	updateBillData(s){
			billDataAdd({"index_id":s.company_id,"sdate":s.bill_sdate,"edate":s.bill_edate,"log":"更新账单"}, this.$cookie.getCookie("login")).then(res => {
			        if (res.code == 200) {
			        	 this.editDialog = false;
			        	 this.$notify({
				          title: '通知',
				          message: res.data.company+ "成功",
				          type: 'success'
				        });
			        	
			        }
			        else{
					        	this.$message.error(res.msg);
					    }
			     });
  	},
  	createBillDataOne(){
  		var arr=[];
  		if(this.cP.index_id!=''){
  				var arr=this.cP.index_id.split(",");
  				console.log(arr);
  				arr.forEach((v,i)=>{
			  			billDataAdd({"index_id":v}, this.$cookie.getCookie("login")).then(res => {
								        if (res.code == 200) {
								        	 this.editDialog = false;
								        	 this.$notify({
									          title: '通知',
									          message: res.data.company+ "成功",
									          type: 'success'
									        });
									      
								        }
								     });
			  		})
  		}
  		else{
  			this.$message.error('请选择需要更新的账单');
  			return false;
  		}
  	
  	

  		
  	},
  	createBillDataALl(id){
  		
  					billDataAdd({"index_id":id}, this.$cookie.getCookie("login")).then(res => {
					        if (res.code == 200) {
					        	 this.editDialog = false;
					        	 this.$notify({
						          title: '通知',
						          message: res.data.company+ "成功",
						          type: 'success'
						        });
						        if(res.data.index_id!==0){
						        	this.createBillDataALl(res.data.index_id);
						        }
					        }
					     });
  		
  
  	},
    getList() {
      var p = "";
      for (var k in this.pdata) {
        if (this.pdata[k]) p += k + "=" + this.pdata[k] + "&";
      }
      getBillDataList(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.plist = res.data.list;
            this.maxPage = res.data.max_page;
        	}
        	else{
        		this.plist = [];
            this.maxPage =1;
        	}
          
        }
      });
      selectCompany('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.companyList = res.data.list;
        	}
          
        }
      });
    },
    getBillList(status,company_id,id) {
      var p = "";
      for (var k in this.bdata) {
        if (this.bdata[k]) p += k + "=" + this.bdata[k] + "&";
      }
      getBillDataDetail('id='+id, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	this.billDialog=true;
        	this.company=res.data.company;
        	this.bill=res.data.bill;
        	this.bill.status=status;
        	this.bill.id=id;
        	this.wecompany=res.data.wecompany;
        	if(res.data.list&&res.data.list.length>0){
        		this.billList = res.data.list;
        	}
        	else{
        		this.billList = []
        	}
          
        }
      });
      selectCompany('', this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
        	if(res.data.list&&res.data.list.length>0){
        		this.companyList = res.data.list;
        	}
          
        }
      });
    },
    openDealy(id) {
  	 	var p = 'type=bill_data&index_id='+id;
      sclog(p, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.logDialog = true;
          this.plog = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    getConfig() {
      if (this.$store.config) {
        this.config = this.$store.config.product_theme;
        this.tags = this.$store.config.product_tag;
        this.option = this.$store.config.product_placement;
      } else {
        setTimeout(() => {
          this.getConfig();
        }, 50);
      }
    },
    statueFilter(s) {
      this.sText = s == "" ? "请选择产品状态" : s == "0" ? "禁用" : "启用";
      this.pdata.status = s;
      this.getList();
    },
    themeFilter(s) {
      this.tText = s == "" ? "请选择产品题材" : s;
      this.pdata.theme = s;
      this.getList();
    },
    placementFilter(s){
    	this.pText = s == "" ? "请选择产品投放位置" : s;
    	this.pdata.placement = s;
    	this.getList();
    },
    search() {
      // this.$refs.input.blur();
      this.getList();
    },
    SizeChange(v) {
      this.pdata.perpage = v;
      this.getList();
    },
    CurrentChange(v) {
      this.pdata.page = v;
      this.getList();
    },
    changeStatus(isSingle, s) {
      if (!isSingle && this.selectProduct.length == 0) {
        this.$message.error("请先选择需要批量操作的数据");
        return;
      }
      if (isSingle) {
        this.cP.index_id = s.id;
        this.cP.status = s.status == 1 ? "0" : "1";
      } else {
        this.cP.status = s;
      }

      if (this.cP.status == 0) {
        this.cP.log = "禁用产品";
      } else if (this.cP.status == 1) {
        this.cP.log = "启用产品";
      } else if (this.cP.status == -1) {
        this.cP.log = "删除产品";
      }
      billDataStatus(this.cP, this.$cookie.getCookie("login")).then(res => {
        if (res.code == 200) {
          this.getList();
          this.$message({ message: this.cP.log + "成功", type: "success" });
        }
      });
    },
    select(s) {
      this.selectProduct = s;
      var p = "测";
      s.forEach((v, i) => {
        p += "," + v.company_id;
      });
      this.cP.index_id = p.slice(2);
    },
    handleAvatarSuccess(res, file) {
      this.imageUrl = URL.createObjectURL(file.raw);
    },
    getInfo(s) {
      this.chooseProduct = JSON.parse(JSON.stringify(s));
      delete this.chooseProduct.id;
      this.chooseProduct.path='';
      this.chooseProduct.placement=''
      this.chooseProduct.log = "新增复用产品";
      this.chooseTags = this.chooseProduct.tags.split(",");
    },
    base64(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
    },
    //替换table数据和worksheet名字
    format (s, c) {
        return s.replace(/{(\w+)}/g,
            function (m, p) {
                return c[p];
            });
    },
    tableToExcel() {
        var uri = 'data:application/vnd.ms-excel;base64,';
        var template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel"' +
            'xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet>'
            + '<x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets>'
            + '</x:ExcelWorkbook></xml><![endif]-->' +
            ' <style type="text/css">' +
            'table td {' +
            'border: 0.1px solid #000000;' +
            'width: 200px;' +
            'height: 30px;' +
            ' text-align: center;' +
            'background-color: #ffffff;' +
            'color: #000000;' +
            ' }' +
            'table th {' +
            'border: 0.1px solid #000000;' +
            'width: 200px;' +
            'height: 30px;' +
            ' text-align: center;' +
            'background-color: #ffffff;' +
            'color: #000000;' +
            ' }' +
            '</style>' +
            '</head><body ><table class="excelTable">{table}</table></body></html>';
            var tableid = document.getElementById('ta');
           
            var ctx = {worksheet: this.company.name+"结算对账单" || 'Worksheet', table: tableid.innerHTML};
        		console.log(uri + this.base64(this.format(template, ctx)));
        	//	location.href = uri + this.base64(this.format(template, ctx));
        	this.base64ToFile(uri + this.base64(this.format(template, ctx)))
    },
    base64ToFile(base) {
      const arr = base.split(',');
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      if (window.navigator.msSaveBlob) {
        // for ie 10 and later
        try {
          const blobObject = new Blob([u8arr], { type: mime });
          window.navigator.msSaveBlob(blobObject,  this.company.name+'.xls');
        } catch (e) {
          console.log(e);
        }
      } else {
        const url = window.URL.createObjectURL(new Blob([u8arr], { type: mime }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', this.company.name+'.xls');
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link); // 下载完成移除元素
        window.URL.revokeObjectURL(url); // 释放掉blob对象
      }
    },
  },
  computed: {
	    ...mapGetters([
	    	'groupid'
	    ])
  },
  created() {
    let that = this;
  },
  mounted() {
    this.getList();
    this.getConfig();
    this.headMsg.token = this.$cookie.getCookie("login");
    this.prWidth = document.getElementById("section").offsetWidth;
  }
};
</script>
<style scoped lang="scss">
.el-table{
overflow:visible !important;
}
.pageRow{
	position: absolute;
	left: 0;
	bottom: -110px;
	width: 100%;
}
span.gn{
	color: #20A0FF;
	cursor: pointer;
}
.dialog {
  width: 800px;
}
.size {
  width: 100px;
  text-align: right;
  position: absolute;
  top: 20px;
  left: -100px;
  padding-right: 14px;
  box-sizing: border-box;
  color: #999;
  font-size: 12px;
}
.bill{

	line-height: 48px;
	text-align: center;
	margin: 20px 0;
	overflow: hidden;
	border-top:1px solid #F2F6FC;
}
.bill .el-row{
	border-bottom:1px solid #F2F6FC;
	border-right:1px solid #F2F6FC;

	
}
.bill .el-row .el-col:first-child{
	
	border-right:1px solid #F2F6FC;
}
</style>

<style >


.el-table--striped .el-table__body tr td{
	background: #FFFFFF;
	
}

.el-table--striped .el-table__body tr td{
	background: #FFFFFF;
	
}
.demo-table .demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
    min-width: 200px;
    padding: 0 25px;
}
.demo-table .demo-table-expand label {

    color: #99a9bf;
}
.el-form--inline .el-form-item__content {
    display: inline-block;
    vertical-align: top;
}
.el-upload-list__item {
  line-height: 0;
}
.selectRow {
  min-width:1200px;padding:15px;background: #fff;
}
.statusRow {
  background: #f2f6fc;
  padding: 15px;
  box-sizing: border-box;
  border-left: 4px solid #409eff;
  min-width: 600px;
}
.statusRow > .el-button {
  margin-right: 6px;
}
.gameIcon {
  width: 60px;
  height: 60px;
  border-radius: 6px;
}
.dropdown {
  min-width: 120px;
  width: 170px;
}
.dropdown-menu {
  width: 170px;
  margin: 0 auto;
  text-align: center;
}
.search,
.input {
  width: 220px;
}
.inline {
  display: inline-block;
  vertical-align: top;
}
.pageRow {
  min-width: 1200px;
  padding: 20px;
  box-sizing: border-box;
  background: #fff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  position: sticky;
  left: 0;
  bottom: -20px;
  z-index: 1000;
}
@media only screen and (max-width: 767px) {
  .phoneHide {
    display: none;
  }
  .search {
    width: 60px;
  }
  .selectRow {
    min-width: 300px;
    padding: 5px;
  }
  .dropdown {
    width: 100%;
  }
  .dropdown-menu {
    width: 100%;
    margin: 0 auto;
    text-align: center;
  }
}
</style>


// WEBPACK FOOTER //
// dataList.vue?1a191bdb